import { z } from 'zod';

import { formatNumber } from '@/utils';

export const PersonalDataSchema = z.object({
    msisdn: z.string().refine(val => String(formatNumber(val)).length === 10),
    email: z.string().email().or(z.literal('')),
});
